import { EyeOff } from "lucide-react";

export function AdPlaceholder() {
	return (
		<aside className="hidden xl:block w-full max-w-[300px]">
			<div className="sticky top-24">
				<div className="relative h-[600px] rounded-lg border-2 border-dashed border-gray-300 bg-white/70 shadow-sm">
					<div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-gray-400 select-none pointer-events-none">
						<EyeOff className="w-5 h-5 opacity-50" />
						<span className="text-sm font-medium opacity-70">
							Google Ad Placeholder
						</span>
					</div>
				</div>
			</div>
		</aside>
	);
}
